import { FC, useEffect } from "react";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import {
  E_ChannelOptions,
  T_GTMBaseEvents,
} from "../../globalTypes/GlobalTypes";
import { isEmpty } from "lodash";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import {
  Abcd_Super_App_Lob_Id,
  DEVICE_TYPE,
  HiDestinationLobId,
  HomeLoansDestinationLobId,
  LiDestinationLobId,
  LoansDestinationLobId,
  MfDestinationLobId,
  OneLoginLobCode,
  SsDestinationLobId,
} from "../../utils/constants";

export class GTM_CLS_COMMON {
  static eventObj: T_GTMBaseEvents = {
    ClientID: "",
    journey_id: "",
    previous_screen_name: "",
  };
  static setBaseData(updatedEventObj: T_GTMBaseEvents) {
    this.eventObj = { ...updatedEventObj };
  }
}
const GtmBaseLogic: FC = () => {
  const deviceType = useDeviceDetection();
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  useEffect(() => {
    const onboardingChannelId =
      csAppSlice.channel === E_ChannelOptions.SUPER_APP
        ? Abcd_Super_App_Lob_Id
        : csAppSlice.channel === E_ChannelOptions.ONE_ABC
        ? OneLoginLobCode
        : csAppSlice.channel === E_ChannelOptions.ABSLI
        ? LiDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABHI
        ? HiDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABSLAMC
        ? MfDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABML
        ? SsDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABHFL
        ? HomeLoansDestinationLobId
        : csAppSlice.channel === E_ChannelOptions.ABFL
        ? LoansDestinationLobId
        : "";
    const clientID = csAppSlice.csUserId || userDetails?.CS_USER_ID || "";
    const isMobile = deviceType === DEVICE_TYPE.MOBILE;
    GTM_CLS_COMMON.setBaseData({
      ClientID: isMobile ? clientID : "",
      previous_screen_name: "",
      journey_id: isEmpty(onboardingChannelId) ? "26" : onboardingChannelId,
    });
  }, [csAppSlice?.csUserId, deviceType]);
  return <></>;
};
export default GtmBaseLogic;
